/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {KTSVG} from '../../../helpers'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'

export function AsideMenuMain() {
  const intl = useIntl()

  return (
    <>
      {/* <AsideMenuItem to='/egitim-videolari' icon='la la-youtube' title='Eğitim Videoları' fontIcon='bi-layers'/> */}
      <li className="navigation-header text-center">
          <div className="row aside-balance-row">
              <div className="col-6 bordered-col">
                  <span data-i18n="nav.category.layouts">GÜNCEL BAKİYE <br/><span className="text-right font-weight-bold">6,219.88 ₺</span></span>
              </div>
              <div className="col-6">
                  <a href="bayi-blokeli-bakiye/2022-01-01/2022-01-10/-1">
                      <span data-i18n="nav.category.layouts" data-toggle="tooltip" data-placement="right" title="" data-original-title="İş ortaklarından hesabınıza aktarılan ama fatura kesilmemiş bakiye tutarıdır.">BLOKE BAKİYE <br/><span className="text-right font-weight-bold">4,345.83 ₺</span></span>
                  </a>
              </div>
          </div>
      </li>
      {/* Menu item */}
      <div className='menu-item seperate-title'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1 color-pink'>HIZLI KAYIT</span>
        </div>
      </div>      
      <AsideMenuItem to='/hizli-arac-on-kayit-formu' icon='la la-car' title='1.Araç Kaydı' fontIcon='bi-layers'/>
      <AsideMenuItem to='/bekleyen-hizli-arac-listesi' icon='la la-list' title='2.Bekleyen Araçlar' fontIcon='bi-layers'/>    
      {/* Menu item end */}
      {/* Menu item */}
      <div className='menu-item seperate-title'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1 color-green'>ARAÇ KAYIT</span>
        </div>
      </div>
      <AsideMenuItem to='/arac-kayit-formu' icon='la la-car' title='Araç - Müşteri Kaydı' fontIcon='bi-layers'/>
      <AsideMenuItem to='/ekspertiz/pilot-kart-kayit' icon='la la-car' title='Pilot Kart Araç Kaydı' fontIcon='bi-layers'/> 
      {/* Menu item end */}
      {/* Menu item */}
      <div className='menu-item seperate-title'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1 color-blue'>EKSPERTİZ İŞLEMLERİ</span>
        </div>
      </div>
      <AsideMenuItem to='/ekspertiz/bekleyen-ekspertiz' icon='la la-users' title='Bekleyen Ekspertizler' fontIcon='bi-layers'/>
      <AsideMenuItem to='/ekspertiz/devam-eden-ekspertiz' icon='la la-hourglass-1' title='Devam Eden Ekspertizler' fontIcon='bi-layers'/> 
      <AsideMenuItem to='/ekspertiz/tamamlanan-ekspertiz' icon='la la-check-circle-o' title='Tamamlanan Ekspertizler' fontIcon='bi-layers'/> 
      <AsideMenuItem to='/ekspertiz/biten-ekspertiz' icon='la la-archive' title='Yapılan Ekspertizler' fontIcon='bi-layers'/> 
      <AsideMenuItem to='/hizli-arac-on-kayit-formu' icon='la la-archive' title='Hasar ve KM Sorgu' fontIcon='bi-layers'/> 
      <AsideMenuItem to='/yaniktesti' icon='la la-fire' title='Conta Yanık Testi' fontIcon='bi-layers'/> 
      <AsideMenuItem to='/bayiler' icon='la la-home' title='Bayiler' fontIcon='bi-layers'/>       
      {/* Menu item end */}
      {/* Menu item */}
      <div className='menu-item seperate-title'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1 color-lightGreen'>PİLOT KART İŞLEMLERİ</span>
        </div>
      </div>
      <AsideMenuItem to='/pilotcard/personel-listesi' icon='la la-user-secret' title='Üye Listem' fontIcon='bi-layers'/>
      <AsideMenuItem to='/ekspertiz/bekleyen-pilot-kart-listele' icon='la la-credit-card' title='Bekleyen Araç Müşteri' fontIcon='bi-layers'/>      
      {/* Menu item end */}
      {/* Menu item */}
      <div className='menu-item seperate-title'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1 color-orange'>EKSPERTİZ ARAMA</span>
        </div>
      </div>
      <AsideMenuItem to='/ekspertiz/tum-bayiler-ekspertiz/filtre-yok' icon='la la-search' title='Tüm Bayilerde Ara' fontIcon='bi-layers'/> 
      {/* Menu item end */}
      {/* Menu item */}
      <div className='menu-item seperate-title'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1 color-purple'>BAYİ İÇİ İŞLEMLER</span>
        </div>
      </div>
      <AsideMenuItem to='/bayi/personel-listesi' icon='la la-users' title='Personel İşlemleri' fontIcon='bi-layers'/> 
      <AsideMenuItem to='/makineler' icon='la la-cogs' title='Makine İşlemleri' fontIcon='bi-layers'/> 
      <AsideMenuItem to='/profilim' icon='la la-user' title='Bayi Profili' fontIcon='bi-layers'/> 
      <AsideMenuItem to='/ofis-detay' icon='la la-user' title='Bayi Fiziki Şartlar' fontIcon='bi-layers'/> 
      <AsideMenuItem to='/bayi/sikayetler/liste' icon='la la-gavel' title='Şikayetler' fontIcon='bi-layers'/> 
      {/* Menu item end */}
      {/* Menu item */}
      <div className='menu-item seperate-title'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1 color-orange-2'>RAPORLAR</span>
        </div>
      </div>
      <AsideMenuItem to='/raporlar/kredi-karti' icon='la la-list' title='Kredi Kartı Dekontları' fontIcon='bi-layers'/> 
      {/* Menu item end */}
      {/* Menu item */}
      <div className='menu-item seperate-title'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1 color-red'>PİLOTGARAGE GARANTİ</span>
        </div>
      </div>
      <AsideMenuItem to='/police' icon='la la-list' title='Garanti Listesi' fontIcon='bi-layers'/> 
      {/* Menu item end */}
      {/* Menu item */}
      <div className='menu-item seperate-title'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1 color-lightYellow'>BAYİ ÖZEL İŞLEMLER</span>
        </div>
      </div>
      <AsideMenuItem to='/bayi/yetki' icon='la la-user-secret' title='Yetki İşlemleri' fontIcon='bi-layers'/> 
      <AsideMenuItem to='/bayi/kimlik' icon='la la-credit-card' title='Bayi Kimlik' fontIcon='bi-layers'/> 
      <AsideMenuItem to='/bayi/bakiye' icon='la la-bank' title='Bakiye İşlemleri' fontIcon='bi-layers'/> 
      <AsideMenuItem to='/bayi/paketler/liste' icon='la la-cubes' title='Paket İşlemleri' fontIcon='bi-layers'/> 
      <AsideMenuItem to='/bayi/kasa/liste' icon='la la-money' title='Kasa İşlemleri' fontIcon='bi-layers'/> 
      <AsideMenuItem to='/hizli-arac-on-kayit-formu' icon='la la-unlock-alt' title='Blokeli Bakiye İşlemleri' fontIcon='bi-layers'/> 
      {/* Menu item end */}
      {/* Menu item */}
      <div className='menu-item seperate-title'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1 color-purple-2'>ÖN MUHASEBE</span>
        </div>
      </div>
      <AsideMenuItem to='/fis-faturalar' icon='la la-money' title='Fiş / Fatura Listesi' fontIcon='bi-layers'/> 
      <AsideMenuItem to='/fis-faturalar/yeni/detayli' icon='la la-plus-circle' title='Yeni Fiş / Fatura' fontIcon='bi-layers'/> 
      {/* Menu item end */}

      
      {/* <AsideMenuItemWithSub
        to='/crafted/pages'
        title='Pages'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen022.svg'
      >
        <AsideMenuItemWithSub to='/crafted/pages/profile' title='Profile' hasBullet={true}>
          <AsideMenuItem to='/crafted/pages/profile/overview' title='Overview' hasBullet={true} />
          <AsideMenuItem to='/crafted/pages/profile/projects' title='Projects' hasBullet={true} />
          <AsideMenuItem to='/crafted/pages/profile/campaigns' title='Campaigns' hasBullet={true} />
          <AsideMenuItem to='/crafted/pages/profile/documents' title='Documents' hasBullet={true} />
          <AsideMenuItem
            to='/crafted/pages/profile/connections'
            title='Connections'
            hasBullet={true}
          />
        </AsideMenuItemWithSub>

        <AsideMenuItemWithSub to='/crafted/pages/wizards' title='Wizards' hasBullet={true}>
          <AsideMenuItem
            to='/crafted/pages/wizards/horizontal'
            title='Horizontal'
            hasBullet={true}
          />
          <AsideMenuItem to='/crafted/pages/wizards/vertical' title='Vertical' hasBullet={true} />
        </AsideMenuItemWithSub>
      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub
        to='/crafted/accounts'
        title='Accounts'
        icon='/media/icons/duotune/communication/com006.svg'
        fontIcon='bi-person'
      >
        <AsideMenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
        <AsideMenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub
        to='/error'
        title='Errors'
        fontIcon='bi-sticky'
        icon='/media/icons/duotune/general/gen040.svg'
      >
        <AsideMenuItem to='/error/404' title='Error 404' hasBullet={true} />
        <AsideMenuItem to='/error/500' title='Error 500' hasBullet={true} />
      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub
        to='/crafted/widgets'
        title='Widgets'
        icon='/media/icons/duotune/general/gen025.svg'
        fontIcon='bi-layers'
      >
        <AsideMenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
      </AsideMenuItemWithSub>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Apps</span>
        </div>
      </div>
      <AsideMenuItemWithSub
        to='/apps/chat'
        title='Chat'
        fontIcon='bi-chat-left'
        icon='/media/icons/duotune/communication/com012.svg'
      >
        <AsideMenuItem to='/apps/chat/private-chat' title='Private Chat' hasBullet={true} />
        <AsideMenuItem to='/apps/chat/group-chat' title='Group Chart' hasBullet={true} />
        <AsideMenuItem to='/apps/chat/drawer-chat' title='Drawer Chart' hasBullet={true} />
      </AsideMenuItemWithSub> */}
      <div className='menu-item'>
        <div className='menu-content'>
          <div className='separator mx-1 my-4'></div>
        </div>
      </div>
      
    </>
  )
}
